import { fetcher } from "@maker/fetcher";

const URL = process.env.BUN_PUBLIC_API_URL;

const api = fetcher.create({
	baseUrl: URL,
});

export { api };
